<template>
  <div>
    <div
      v-if="!transaction"
      class="text-center py-5"
    >
      <b-spinner variant="primary" />
      <div class="mt-1">
        Memuat transaksi...
      </div>
    </div>

    <div
      v-if="canAccess('manage', 'Transaction') && transaction && transaction.status === 'accepted'"
      class="mb-1 text-right"
    >
      <div
        v-if="brand && brand.address && transaction.delivery && (transaction.delivery.courier === 'jne' || transaction.delivery.courier === 'jnt') && transaction.delivery.service !== 'ROCKET'"
        class="d-inline-block mr-75"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="pl-75"
          :disabled="!brand.address.is_pickup_jne_enabled"
          @click="onRequestPickup"
        ><feather-icon
          icon="TruckIcon"
          class="mr-50"
        /> Request Pickup
        </b-button>
      </div>

      <div
        v-if="brand && brand.address && transaction && transaction.delivery && transaction.delivery.courier === 'jne' && transaction.delivery.service === 'ROCKET'"
        class="d-inline-block mr-75"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="pl-75"
          :disabled="!brand.address.is_pickup_jne_enabled"
          @click="onRequestPickupRocket"
        ><feather-icon
          icon="TruckIcon"
          class="mr-50"
        /> Request Pickup (Rocket)
        </b-button>
      </div>

      <div
        v-if="brand && brand.address && transaction.delivery && transaction.delivery.courier === 'jne' && transaction.delivery.service !== 'ROCKET'"
        class="d-inline-block border-right border-right-2 mr-75 pr-75"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="secondary"
          class="pl-75"
          :disabled="!brand.address.is_pickup_jne_enabled"
          @click="onRequestDropOff"
        ><feather-icon
          icon="ArchiveIcon"
          class="mr-50"
        /> Request Drop-off
        </b-button>
      </div>

      <b-button
        v-if="transaction.transaction_type === 'gift_registry.contribute'"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="pl-75"
        @click="onTandaiDelivered"
      ><feather-icon
        icon="CheckIcon"
        class="mr-25"
      /> Tandai kontribusi selesai
      </b-button>

      <b-button
        v-else
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="pl-75"
        @click="onTandaiDikirim"
      ><feather-icon
        icon="CheckIcon"
        class="mr-50"
      /> Tandai telah dikirim
      </b-button>

      <b-button
        v-if="transaction.transaction_type !== 'gift_registry.contribute'"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="secondary"
        class="ml-75 pl-75"
        @click="$router.push({ name: 'transactions-packing-label', params: { id: $route.params.id } })"
      ><feather-icon
        icon="PrinterIcon"
        class="mr-50"
      /> Cetak Label
      </b-button>

      <b-dropdown
        variant="white"
        no-caret
        toggle-class="px-1"
        right
      >
        <template #button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="16"
          />
        </template>
        <b-dropdown-item
          :to="`/transactions/${$route.params.id}/invoice?invoice=${transaction.invoice_number}`"
        >
          <span>Lihat Invoice</span>
        </b-dropdown-item>
        <b-dropdown-item
          @click="isShowModalActivities = true"
        >
          <span>Riwayat Pesanan</span>
        </b-dropdown-item>
        <b-dropdown-item
          @click="onCancelPesanan"
        >
          <span class="text-danger">Batalkan Pesanan</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <div
      v-if="(transaction && transaction.status === 'pickedup') || (transaction && transaction.status === 'pickup_requested')"
      class="mb-1 text-right"
    >
      <div
        v-if="transaction && transaction.delivery && transaction.delivery.airway_bill"
        class="d-inline-block border-right border-right-2 mr-75 pr-75"
      >
        <b-button
          v-if="canAccess('read', 'Transaction')"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="d-inline-block border-right border-right-2 mr-75 pl-75"
          @click="onTrack"
        ><feather-icon
          icon="TruckIcon"
          class="mr-50"
        /> Lacak Pengiriman
        </b-button>
      </div>

      <b-button
        v-if="transaction.transaction_type !== 'gift_registry.contribute'"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="ml-75 pl-75"
        variant="secondary"
        @click="$router.push({ name: 'transactions-packing-label', params: { id: $route.params.id } })"
      ><feather-icon
        icon="PrinterIcon"
        class="mr-50"
      /> Cetak Label
      </b-button>

      <b-button
        v-if="canAccess('manage', 'Transaction')"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="ml-75 pl-75"
        variant="primary"
        @click="onTandaiDelivered"
      ><feather-icon
        icon="CheckIcon"
        class="mr-50"
      /> Tandai Pesanan Selesai
      </b-button>

      <b-dropdown
        variant="white"
        no-caret
        toggle-class="px-1"
        right
      >
        <template #button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="16"
          />
        </template>
        <b-dropdown-item
          :to="`/transactions/${$route.params.id}/invoice?invoice=${transaction.invoice_number}`"
        >
          <span>Lihat Invoice</span>
        </b-dropdown-item>
        <b-dropdown-item
          @click="isShowModalActivities = true"
        >
          <span>Riwayat Pesanan</span>
        </b-dropdown-item>
        <b-dropdown-item
          @click="onRequestChangeAwb"
        >
          <span>Ubah No. Resi</span>
        </b-dropdown-item>
        <b-dropdown-item
          @click="onRequestChangeCourier"
        >
          <span>Ubah Kurir</span>
        </b-dropdown-item>
        <b-dropdown-item
          @click="onRequestCancelDelivery"
        >
          <span>Batalkan Pengiriman</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <div
      v-if="(transaction && transaction.status === 'delivered') || (transaction && transaction.status === 'confirmed') || (transaction && transaction.status === 'cancelled')"
      class="mb-1 text-right"
    >
      <div
        v-if="transaction && transaction.delivery && transaction.delivery.airway_bill"
        class="d-inline-block border-right border-right-2 mr-75 pr-75"
      >
        <b-button
          v-if="canAccess('read', 'Transaction')"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="d-inline-block border-right border-right-2 mr-75 pl-75"
          @click="onTrack"
        ><feather-icon
          icon="TruckIcon"
          class="mr-50"
        /> Lihat Pengiriman
        </b-button>
      </div>

      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        :to="`/transactions/${$route.params.id}/invoice?invoice=${transaction.invoice_number}`"
        variant="primary"
        class="ml-75 pl-75"
      ><feather-icon
        icon="FileTextIcon"
        class="mr-50"
      /> Lihat Invoice
      </b-button>

      <b-dropdown
        variant="white"
        no-caret
        toggle-class="px-1"
        right
      >
        <template #button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="16"
          />
        </template>
        <b-dropdown-item
          @click="isShowModalActivities = true"
        >
          <span>Riwayat Pesanan</span>
        </b-dropdown-item>
        <b-dropdown-item
          v-if="transaction.status === 'confirmed'"
          @click="onCancelPesanan"
        >
          <span class="text-danger">Batalkan Pesanan</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <b-row>
      <b-col cols="8">
        <PembeliAlamat
          v-if="transaction"
          :data="transaction"
        />
        <DaftarProduk
          v-if="transaction"
          :product-list="transaction.items"
          :use-gift-wrap="transaction.use_gift_wrap"
        />
      </b-col>
      <b-col>
        <InfoTransaksi
          v-if="transaction"
          :data="transaction"
        />
      </b-col>
    </b-row>

    <hr
      v-if="transaction && $store.state.auth.userData.role === 'admin'"
      class="mb-3"
    >

    <b-row v-if="transaction && $store.state.auth.userData.role === 'admin'">
      <b-col
        v-if="transaction"
        cols="7"
      >
        <DaftarPembayaran
          :data="transaction"
          @reload="reload"
        />
      </b-col>
      <b-col v-if="transaction">
        <Pembayaran
          :data="transaction"
        />
      </b-col>
    </b-row>

    <modal-tandai-dikirim
      v-if="canAccess('manage', 'Transaction') && transaction"
      :open="isShowModalTandaiDikirim"
      :hide="() => isShowModalTandaiDikirim = false"
      :data="transaction"
      @callback="reloadData"
    />

    <modal-tandai-delivered
      v-if="canAccess('manage', 'Transaction') && transaction"
      :open="isShowModalTandaiDelivered"
      :hide="() => isShowModalTandaiDelivered = false"
      :data="transaction"
      @callback="reloadData"
    />

    <modal-force-delivered
      v-if="canAccess('manage', 'Transaction') && transaction"
      :open="isShowModalForceDelivered"
      :hide="() => isShowModalForceDelivered = false"
      :data="transaction"
      @callback="reloadData"
    />

    <modal-cancel-pesanan
      v-if="canAccess('manage', 'Transaction') && transaction"
      :open="isShowModalCancelPesanan"
      :hide="() => isShowModalCancelPesanan = false"
      :data="transaction"
      @callback="reloadData"
    />

    <modal-request-pickup
      v-if="canAccess('manage', 'Transaction') && transaction"
      :open="isShowModalRequestPickup"
      :hide="() => isShowModalRequestPickup = false"
      :data="transaction"
      @callback="reloadData"
    />

    <b-modal
      v-model="isShowModalRequestDropOff"
      title="Request Drop-off"
      ok-title="Ya, yakin"
      :ok-disabled="loadingSubmitDropOff"
      @ok.prevent="dropOff"
    >
      No resi akan dibuat untuk Drop-off. Apakah Anda yakin?
    </b-modal>

    <b-modal
      v-model="isShowModalRequestPickupRocket"
      title="Request Drop-off"
      ok-title="Ya, yakin"
      :ok-disabled="loadingSubmitPickup"
      @ok.prevent="pickupRocket"
    >
      Kurir akan segera menjemput ke lokasi merchant. Apakah Anda yakin?
    </b-modal>

    <b-modal
      v-model="isShowModalChangeAwb"
      title="Ubah Nomor Resi"
      ok-title="Simpan"
      cancel-title="Batal"
      :ok-disabled="!awb || loadingSubmitChangeResi"
      :cancel-disabled="loadingSubmitChangeResi"
      @hidden="isShowModalChangeAwb = false"
      @ok.prevent="changeAwb"
    >
      <b-card-text>
        <b-form-group
          label="No. Resi Baru"
          label-for="noResi"
        >
          <b-form-input
            id="noResi"
            v-model="awb"
            placeholder="Isi No. Resi"
          />
        </b-form-group>
      </b-card-text>
      <b-card-text v-if="transaction && transaction.delivery && (transaction.delivery.pickup_requested_at || transaction.delivery.dropoff_requested_at)">
        <label for="note-change-awb">Catatan:</label>
        <div id="note-change-awb">
          Harap sampaikan ke {{ $store.state.auth.userData.type === 'admin' ? `pihak ${transaction.delivery.courier.toUpperCase()}` : 'Admin Miniapoly' }} bahwa permintaan <span v-if="transaction.delivery.pickup_requested_at">
            Pick Up
          </span>
          <span v-else-if="transaction.delivery.dropoff_requested_at">
            Drop-off
          </span>
          <span v-else>
            Drop-off
          </span> transaksi ini dibatalkan sebelum mengubah No. Resi.
        </div>
      </b-card-text>
    </b-modal>

    <b-modal
      v-model="isShowModalChangeCourier"
      title="Ubah Kurir"
      ok-title="Simpan"
      cancel-title="Batal"
      :ok-disabled="!courier || loadingSubmitChangeCourier"
      :cancel-disabled="loadingSubmitChangeCourier"
      @hidden="isShowModalChangeCourier = false"
      @ok.prevent="changeCourier"
    >
      <b-form-group
        label="Pilih Kurir"
        label-for="courier"
      >
        <v-select
          id="courier"
          v-model="courier"
          label="name"
          :options="courierList"
        />
      </b-form-group>
      <b-form-group
        label="Layanan Kurir (Opsional)"
        label-for="courierService"
      >
        <b-form-input
          id="courierService"
          v-model="courierService"
          placeholder="Pilih layanan kurir"
        />
      </b-form-group>
    </b-modal>

    <b-modal
      v-model="isShowModalCancelDelivery"
      title="Batalkan Pengiriman"
      ok-title="Submit"
      cancel-title="Batal"
      :ok-disabled="loadingSubmitCancelDelivery"
      :cancel-disabled="loadingSubmitCancelDelivery"
      @hidden="isShowModalCancelDelivery = false"
      @ok.prevent="cancelDelivery"
    >
      <b-card-text>
        Pengiriman akan dibatalkan dan No. Resi akan dihapus. Apakah Anda yakin?
      </b-card-text>

      <hr v-if="transaction && transaction.delivery && (transaction.delivery.courier === 'jne' || transaction.delivery.courier === 'jnt') && (transaction.delivery.pickup_requested_at || transaction.delivery.dropoff_requested_at)">
      <b-card-text v-if="transaction && transaction.delivery && (transaction.delivery.courier === 'jne' || transaction.delivery.courier === 'jnt') && (transaction.delivery.pickup_requested_at || transaction.delivery.dropoff_requested_at)">
        <label for="note-change-awb">Catatan:</label>
        <div id="note-change-awb">
          Harap sampaikan ke {{ $store.state.auth.userData.type === 'admin' ? `pihak ${transaction.delivery.courier.toUpperCase()}` : 'Admin Miniapoly' }} bahwa permintaan <span v-if="transaction.delivery.pickup_requested_at">
            Pick Up
          </span>
          <span v-else-if="transaction.delivery.dropoff_requested_at">
            Drop-off
          </span>
          <span v-else>
            Drop-off
          </span> transaksi ini dibatalkan sebelum membatalkan pengiriman.
        </div>
      </b-card-text>
    </b-modal>

    <b-modal
      v-model="isShowModalTrack"
      title="Lacak Pengiriman"
      ok-title="Selesai"
      ok-only
    >
      <div
        v-if="photoHistory && photoHistory.length"
        class="form-row overflow-x-auto overflow-y-hidden pb-1 flex-nowrap"
        style="height: calc(100px + 1rem)"
      >
        <a
          v-for="(item, index) in photoHistory"
          :key="`photo-history-${index}`"
          :href="`/preview-image?url=${item.url}`"
          target="_blank"
          class="position-relative d-block col-auto mb-n5"
        >
          <img
            v-b-tooltip.hover.bottom="{title: item.date, disabled: !item.date}"
            :src="item.url"
            width="100px"
            height="100px"
            class="position-relative rounded-lg mb-5"
          >
        </a>
      </div>

      <hr
        v-if="photoHistory && photoHistory.length"
        class="mb-2 mt-50"
      >

      <ul
        v-if="trackHistory.length"
        data-v-879a380c=""
        class="app-timeline mt-1 pt-25"
      >
        <li
          v-for="(item, index) in trackHistory"
          :key="`list-item-status-${index}`"
          data-v-4d50203e=""
          class="timeline-item"
          :class="{'timeline-variant-primary': index === 0, 'timeline-variant-secondary': index > 0}"
          data-v-879a380c=""
        >
          <div
            data-v-4d50203e=""
            class="timeline-item-point"
          />
          <div
            data-v-4d50203e=""
            class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1"
          >
            <h6
              v-if="item.desc_parts"
              data-v-4d50203e=""
              class="text-capitalize"
            ><span
              v-for="(descPart, descPartIndex) in item.desc_parts"
              :key="`list-item-status-${index}-${descPartIndex}`"
            ><span
              v-if="descPart.type === 'text'"
              class="text-capitalize"
            >{{ descPart.text.toLowerCase() }}</span><span
              v-if="descPart.type === 'array' && descPart.array.length"
              v-b-tooltip.hover.top="{title: descPart.array.join(', '), disabled: descPart.array.length <= 1}"
              :class="{'text-underline': descPart.array.length > 1}"
            >{{ descPart.array[0] }}</span></span>
            </h6><h6
              v-else-if="item.desc"
              data-v-4d50203e=""
              class="text-capitalize"
            >
              {{ item.desc.toLowerCase().replace(/ *\[[^\]]*]/, '').replace('delivered to', 'delivered') }}
            </h6><small
              data-v-4d50203e=""
              class="timeline-item-time text-nowrap text-muted ml-1"
            >{{ getDate(item.date) }}</small>
          </div>
          <p
            v-if="item.location"
            class="text-capitalize"
            data-v-4d50203e=""
          >
            {{ item.location.toLowerCase() }}
          </p>
          <p
            v-else-if="item.desc.toLowerCase().match(/\[(.*?)\]/)"
            class="text-capitalize"
            data-v-4d50203e=""
          >
            {{ item.desc.toLowerCase().match(/\[(.*?)\]/)[1] }}
          </p>
        </li>
      </ul>
      <div
        v-else-if="!isLoadingTracking"
        class="text-secondary text-center py-3"
      >
        <div class="mb-1">
          <feather-icon
            icon="ClockIcon"
            size="32"
          />
        </div>
        <p class="mb-25">
          Pengiriman belum dapat dilacak.
        </p>
        <p>Harap periksa kembali dalam beberapa jam.</p>
      </div>
      <div
        v-else
        class="text-center py-5"
      >
        <b-spinner variant="primary" />
        <div class="mt-1">
          Melacak pengiriman...
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="isShowModalActivities"
      title="Riwayat Pesanan"
      ok-title="Selesai"
      ok-only
    >
      <ul
        v-if="transaction && transaction.activities && transaction.activities.length"
        class="app-timeline mt-1 pt-25"
      >
        <li
          v-for="(activity, index) in transaction.activities"
          :key="`list-item-activity-${index}`"
          data-v-4d50203e=""
          class="timeline-item"
          :class="{'timeline-variant-primary': index === 0, 'timeline-variant-secondary': index > 0}"
        >
          <div
            data-v-4d50203e=""
            class="timeline-item-point"
          />
          <div
            data-v-4d50203e=""
            class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1"
          >
            <h6
              data-v-4d50203e=""
              class="font-weight-bold"
            >
              {{ activity.description }}
            </h6>
            <small
              data-v-4d50203e=""
              class="timeline-item-time text-nowrap text-muted ml-1"
            >{{ activityDate(activity.created_at) }}</small>
          </div>
          <p
            v-if="activity.actor_type"
            data-v-4d50203e=""
            class="text-muted mb-0"
          >
            {{ activity.actor_name || actorLabel(activity.actor_type) }}
            <span v-if="activity.from_status && activity.to_status && activity.from_status !== activity.to_status">
              · {{ activity.from_status }} → {{ activity.to_status }}
            </span>
          </p>
        </li>
      </ul>
      <div
        v-else
        class="text-secondary text-center py-3"
      >
        <div class="mb-1">
          <feather-icon
            icon="ClockIcon"
            size="32"
          />
        </div>
        <p class="mb-25">
          Belum ada aktivitas tercatat.
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BRow,
  BCol,
  BButton,
  BDropdown,
  BDropdownItem, VBTooltip,
  BSpinner, BModal, BFormInput, BFormGroup, BCardText,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import vSelect from 'vue-select'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PembeliAlamat from './PembeliAlamat.vue'
import InfoTransaksi from './InfoTransaksi.vue'
import DaftarProduk from './DaftarProduk.vue'
import DaftarPembayaran from './DaftarPembayaran.vue'
import Pembayaran from './Pembayaran.vue'
import ModalTandaiDikirim from './ModalTandaiDikirim.vue'
import ModalForceDelivered from './ModalForceDelivered.vue'
import ModalTandaiDelivered from './ModalTandaiDelivered.vue'
import ModalCancelPesanan from './ModalCancelPesanan.vue'
import ModalRequestPickup from './ModalRequestPickup.vue'

export default {
  components: {
    BCardText,
    BFormGroup,
    BFormInput,
    BModal,
    BRow,
    BCol,
    BButton,
    BDropdown,
    BDropdownItem,
    BSpinner,
    vSelect,

    PembeliAlamat,
    InfoTransaksi,
    DaftarProduk,
    DaftarPembayaran,
    Pembayaran,
    ModalTandaiDikirim,
    ModalTandaiDelivered,
    ModalCancelPesanan,
    ModalForceDelivered,
    ModalRequestPickup,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      productList: [],
      transactionId: this.$route.params.id,
      awb: '',
      courier: '',
      courierService: '',
      courierList: [],
      isShowModalTandaiDikirim: false,
      isShowModalTandaiDelivered: false,
      isShowModalCancelPesanan: false,
      isShowModalRequestPickup: false,
      isShowModalRequestPickupRocket: false,
      isShowModalChangeAwb: false,
      isShowModalChangeCourier: false,
      isShowModalCancelDelivery: false,
      isShowModalRequestDropOff: false,
      isShowModalForceDelivered: false,
      isShowModalTrack: false,
      isShowModalActivities: false,
      isLoadingTracking: false,
      loadingSubmitDropOff: false,
      loadingSubmitPickup: false,
      loadingSubmitChangeResi: false,
      loadingSubmitChangeCourier: false,
      loadingSubmitCancelDelivery: false,
    }
  },
  computed: {
    ...mapState('brand', ['brand']),
    ...mapState('transaction', ['transaction', 'trackHistory', 'photoHistory', 'trackStatus']),
  },
  async created() {
    if (this.transaction && this.transaction.id !== this.transactionId) {
      this.$store.commit('brand/SET_BRAND', null)
      this.$store.commit('brand/SET_SELECTED_COURIERS', null)

      this.$store.commit('transaction/SET_TRANSACTION', null)
      this.$store.commit('transaction/SET_TRACK_HISTORY', [])
      this.$store.commit('transaction/SET_TRACKING_STATUS', '')
    }

    this.isPending = true
    await this.getDetailTransaction(this.$route.params.id)
    this.getBrand({ id: this.transaction.merchant.id })

    this.isPending = false
    moment.locale('id')
  },
  destroyed() {
    if (!this.$route.path.includes('/transactions/') || (this.$route.params.id !== this.transactionId)) {
      this.$store.commit('brand/SET_BRAND', null)
      this.$store.commit('brand/SET_SELECTED_COURIERS', null)

      this.$store.commit('transaction/SET_TRANSACTION', null)
      this.$store.commit('transaction/SET_TRACK_HISTORY', [])
      this.$store.commit('transaction/SET_TRACKING_STATUS', '')
    }
  },
  methods: {
    ...mapActions('brand', [
      'getBrand',
    ]),
    ...mapActions('transaction', ['onChangeAwb', 'onChangeCourier', 'onCancelDelivery', 'getDetailTransaction', 'getTrack', 'requestDropOff', 'requestPickupRocket']),
    getDate(date) {
      const firstPart = date.split('-')

      if (firstPart.length > 1 && firstPart[0].length === 4) {
        return moment(date, 'YYYY-MM-DD HH:mm').fromNow()
      }

      return moment(date, 'DD-MM-YYYY HH:mm').fromNow()
    },
    activityDate(date) {
      return date ? moment(date).locale('id').format('D MMM YYYY, HH:mm') : '-'
    },
    actorLabel(type) {
      const labels = {
        system: 'Sistem',
        gateway: 'Gateway pembayaran',
        customer: 'Pembeli',
        admin: 'Admin',
        brand: 'Brand',
      }
      return labels[type] || type
    },
    async reload(id) {
      this.isPending = true
      await this.getDetailTransaction(id)
      this.isPending = false
    },
    onTandaiDikirim() {
      this.isShowModalTandaiDikirim = true
    },
    onTandaiDelivered() {
      this.isShowModalTandaiDelivered = true
    },
    onRequestPickup() {
      this.isShowModalRequestPickup = true
    },
    onRequestPickupRocket() {
      this.isShowModalRequestPickupRocket = true
    },
    onRequestChangeAwb() {
      this.isShowModalChangeAwb = true
    },
    async onRequestChangeCourier() {
      this.isShowModalChangeCourier = true

      const response = await this.$store.dispatch('courier/getCourierList')

      this.courierService = this.transaction.delivery.service

      if (response && response.data && response.data.rows) {
        this.courierList = response.data.rows
      } else {
        this.courierList = []
      }

      this.courier = this.courierList.find(item => item.code === this.transaction.delivery.courier)
    },
    onRequestCancelDelivery() {
      this.isShowModalCancelDelivery = true
    },
    onRequestDropOff() {
      this.isShowModalRequestDropOff = true
    },
    onTrack() {
      this.isShowModalTrack = true

      if ((this.transaction.status === 'pickedup' || this.transaction.status === 'pickup_requested' || this.transaction.status === 'delivered') && this.transaction.delivery) {
        if (this.transaction.id) {
          this.isLoadingTracking = true

          this.getTrack({ transaction: this.transaction.id })
            .then(data => {
              if (data && data.status && data.status.toLowerCase() === 'delivered' && this.transaction.status !== 'delivered') {
                this.isShowModalForceDelivered = true
              }
            })
            .finally(() => {
              this.isLoadingTracking = false
            })
        }
      }
    },
    async reloadData() {
      this.isPending = true
      await this.getDetailTransaction(this.$route.params.id)
      this.isPending = false
    },
    onCancelPesanan() {
      this.isShowModalCancelPesanan = true
    },
    changeAwb() {
      this.loadingSubmitChangeResi = true

      this.onChangeAwb({ idTransaction: this.$route.params.id, resi: this.awb })
        .then(async () => {
          this.awb = ''
          this.isShowModalChangeAwb = false
          this.loadingSubmitChangeResi = false

          await this.getDetailTransaction(this.$route.params.id)
        })
        .catch(() => {
          this.loadingSubmitChangeResi = false
        })
        .finally(() => {
          this.loadingSubmitChangeResi = false
        })
    },
    changeCourier() {
      this.loadingSubmitChangeCourier = true

      this.onChangeCourier({
        idTransaction: this.$route.params.id,
        courierId: this.courier.id,
        service: this.courierService,
      })
        .then(async () => {
          this.awb = ''
          this.isShowModalChangeCourier = false
          this.loadingSubmitChangeCourier = false

          await this.getDetailTransaction(this.$route.params.id)
        })
        .catch(() => {
          this.loadingSubmitChangeCourier = false
        })
        .finally(() => {
          this.loadingSubmitChangeCourier = false
        })
    },
    cancelDelivery() {
      this.loadingSubmitCancelDelivery = true

      this.onCancelDelivery({ idTransaction: this.$route.params.id })
        .then(async () => {
          this.awb = ''
          await this.getDetailTransaction(this.$route.params.id)
          this.isShowModalCancelDelivery = false
          this.loadingSubmitCancelDelivery = false
        })
        .catch(() => {
          this.loadingSubmitCancelDelivery = false
        })
        .finally(() => {
          this.loadingSubmitCancelDelivery = false
        })
    },
    async dropOff() {
      this.loadingSubmitDropOff = true

      this.requestDropOff({
        id: this.$route.params.id,
        data: {},
      })
        .then(() => {
          this.isShowModalRequestDropOff = false
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Request Drop-off gagal!',
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          this.loadingSubmitDropOff = false
        })
    },
    async pickupRocket() {
      this.loadingSubmitPickup = true

      this.requestPickupRocket({
        id: this.$route.params.id,
        data: {},
      })
        .then(() => {
          this.isShowModalRequestPickupRocket = false
          this.reloadData()
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Request Pickup gagal!',
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          this.loadingSubmitPickup = false
        })
    },
  },
}
</script>

<style>

.app-timeline {
  list-style: none;
  position: relative
}

[dir] .app-timeline {
  padding: 0;
  margin: 0
}

[dir=ltr] .app-timeline {
  margin-left: 1rem
}

[dir=rtl] .app-timeline {
  margin-right: 1rem
}

[dir] .timeline-variant-white.timeline-item-fill-border-white[data-v-4d50203e] {
  border-color: #fff !important
}

[dir] .timeline-variant-white.timeline-item-fill-border-white[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#fff));
  background: linear-gradient(#fff, #fff)
}

[dir] .timeline-variant-white .timeline-item-point[data-v-4d50203e] {
  background-color: #fff
}

[dir] .timeline-variant-white .timeline-item-point[data-v-4d50203e]:before {
  background-color: hsla(0, 0%, 100%, .12)
}

.timeline-variant-white .timeline-item-icon[data-v-4d50203e] {
  color: #fff
}

[dir] .timeline-variant-white .timeline-item-icon[data-v-4d50203e] {
  border: 1px solid #fff
}

[dir] .timeline-variant-black.timeline-item-fill-border-black[data-v-4d50203e] {
  border-color: #000 !important
}

[dir] .timeline-variant-black.timeline-item-fill-border-black[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#000), to(#fff));
  background: linear-gradient(#000, #fff)
}

[dir] .timeline-variant-black .timeline-item-point[data-v-4d50203e] {
  background-color: #000
}

[dir] .timeline-variant-black .timeline-item-point[data-v-4d50203e]:before {
  background-color: rgba(0, 0, 0, .12)
}

.timeline-variant-black .timeline-item-icon[data-v-4d50203e] {
  color: #000
}

[dir] .timeline-variant-black .timeline-item-icon[data-v-4d50203e] {
  border: 1px solid #000
}

[dir] .timeline-variant-dark.timeline-item-fill-border-dark[data-v-4d50203e] {
  border-color: #4b4b4b !important
}

[dir] .timeline-variant-dark.timeline-item-fill-border-dark[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#4b4b4b), to(#fff));
  background: linear-gradient(#4b4b4b, #fff)
}

[dir] .timeline-variant-dark .timeline-item-point[data-v-4d50203e] {
  background-color: #4b4b4b
}

[dir] .timeline-variant-dark .timeline-item-point[data-v-4d50203e]:before {
  background-color: rgba(75, 75, 75, .12)
}

.timeline-variant-dark .timeline-item-icon[data-v-4d50203e] {
  color: #4b4b4b
}

[dir] .timeline-variant-dark .timeline-item-icon[data-v-4d50203e] {
  border: 1px solid #4b4b4b
}

[dir] .timeline-variant-light.timeline-item-fill-border-light[data-v-4d50203e] {
  border-color: #f6f6f6 !important
}

[dir] .timeline-variant-light.timeline-item-fill-border-light[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#f6f6f6), to(#fff));
  background: linear-gradient(#f6f6f6, #fff)
}

[dir] .timeline-variant-light .timeline-item-point[data-v-4d50203e] {
  background-color: #f6f6f6
}

[dir] .timeline-variant-light .timeline-item-point[data-v-4d50203e]:before {
  background-color: hsla(0, 0%, 96.5%, .12)
}

.timeline-variant-light .timeline-item-icon[data-v-4d50203e] {
  color: #f6f6f6
}

[dir] .timeline-variant-light .timeline-item-icon[data-v-4d50203e] {
  border: 1px solid #f6f6f6
}

[dir] .timeline-variant-primary.timeline-item-fill-border-primary[data-v-4d50203e] {
  border-color: #7367f0 !important
}

[dir] .timeline-variant-primary.timeline-item-fill-border-primary[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#7367f0), to(#fff));
  background: linear-gradient(#7367f0, #fff)
}

[dir] .timeline-variant-primary .timeline-item-point[data-v-4d50203e] {
  background-color: #7367f0
}

[dir] .timeline-variant-primary .timeline-item-point[data-v-4d50203e]:before {
  background-color: rgba(115, 103, 240, .12)
}

.timeline-variant-primary .timeline-item-icon[data-v-4d50203e] {
  color: #7367f0
}

[dir] .timeline-variant-primary .timeline-item-icon[data-v-4d50203e] {
  border: 1px solid #7367f0
}

[dir] .timeline-variant-secondary.timeline-item-fill-border-secondary[data-v-4d50203e] {
  border-color: #82868b !important
}

[dir] .timeline-variant-secondary.timeline-item-fill-border-secondary[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#82868b), to(#fff));
  background: linear-gradient(#82868b, #fff)
}

[dir] .timeline-variant-secondary .timeline-item-point[data-v-4d50203e] {
  background-color: #82868b
}

[dir] .timeline-variant-secondary .timeline-item-point[data-v-4d50203e]:before {
  background-color: rgba(130, 134, 139, .12)
}

.timeline-variant-secondary .timeline-item-icon[data-v-4d50203e] {
  color: #82868b
}

[dir] .timeline-variant-secondary .timeline-item-icon[data-v-4d50203e] {
  border: 1px solid #82868b
}

[dir] .timeline-variant-success.timeline-item-fill-border-success[data-v-4d50203e] {
  border-color: #28c76f !important
}

[dir] .timeline-variant-success.timeline-item-fill-border-success[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#28c76f), to(#fff));
  background: linear-gradient(#28c76f, #fff)
}

[dir] .timeline-variant-success .timeline-item-point[data-v-4d50203e] {
  background-color: #28c76f
}

[dir] .timeline-variant-success .timeline-item-point[data-v-4d50203e]:before {
  background-color: rgba(40, 199, 111, .12)
}

.timeline-variant-success .timeline-item-icon[data-v-4d50203e] {
  color: #28c76f
}

[dir] .timeline-variant-success .timeline-item-icon[data-v-4d50203e] {
  border: 1px solid #28c76f
}

[dir] .timeline-variant-info.timeline-item-fill-border-info[data-v-4d50203e] {
  border-color: #00cfe8 !important
}

[dir] .timeline-variant-info.timeline-item-fill-border-info[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#00cfe8), to(#fff));
  background: linear-gradient(#00cfe8, #fff)
}

[dir] .timeline-variant-info .timeline-item-point[data-v-4d50203e] {
  background-color: #00cfe8
}

[dir] .timeline-variant-info .timeline-item-point[data-v-4d50203e]:before {
  background-color: rgba(0, 207, 232, .12)
}

.timeline-variant-info .timeline-item-icon[data-v-4d50203e] {
  color: #00cfe8
}

[dir] .timeline-variant-info .timeline-item-icon[data-v-4d50203e] {
  border: 1px solid #00cfe8
}

[dir] .timeline-variant-warning.timeline-item-fill-border-warning[data-v-4d50203e] {
  border-color: #ff9f43 !important
}

[dir] .timeline-variant-warning.timeline-item-fill-border-warning[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#ff9f43), to(#fff));
  background: linear-gradient(#ff9f43, #fff)
}

[dir] .timeline-variant-warning .timeline-item-point[data-v-4d50203e] {
  background-color: #ff9f43
}

[dir] .timeline-variant-warning .timeline-item-point[data-v-4d50203e]:before {
  background-color: rgba(255, 159, 67, .12)
}

.timeline-variant-warning .timeline-item-icon[data-v-4d50203e] {
  color: #ff9f43
}

[dir] .timeline-variant-warning .timeline-item-icon[data-v-4d50203e] {
  border: 1px solid #ff9f43
}

[dir] .timeline-variant-danger.timeline-item-fill-border-danger[data-v-4d50203e] {
  border-color: #ea5455 !important
}

[dir] .timeline-variant-danger.timeline-item-fill-border-danger[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#ea5455), to(#fff));
  background: linear-gradient(#ea5455, #fff)
}

[dir] .timeline-variant-danger .timeline-item-point[data-v-4d50203e] {
  background-color: #ea5455
}

[dir] .timeline-variant-danger .timeline-item-point[data-v-4d50203e]:before {
  background-color: rgba(234, 84, 85, .12)
}

.timeline-variant-danger .timeline-item-icon[data-v-4d50203e] {
  color: #ea5455
}

[dir] .timeline-variant-danger .timeline-item-icon[data-v-4d50203e] {
  border: 1px solid #ea5455
}

.timeline-item[data-v-4d50203e] {
  position: relative
}

[dir=ltr] .timeline-item[data-v-4d50203e] {
  padding-left: 2.5rem
}

[dir=rtl] .timeline-item[data-v-4d50203e] {
  padding-right: 2.5rem
}

[dir] .timeline-item[data-v-4d50203e]:not(:last-of-type) {
  padding-bottom: 1rem
}

[dir=ltr] .timeline-item[data-v-4d50203e]:not(:last-of-type) {
  border-left: 1px solid #ebe9f1
}

[dir=rtl] .timeline-item[data-v-4d50203e]:not(:last-of-type) {
  border-right: 1px solid #ebe9f1
}

.timeline-item[data-v-4d50203e]:last-of-type:after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 1px;
  height: 100%
}

[dir] .timeline-item[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#ebe9f1), to(#fff));
  background: linear-gradient(#ebe9f1, #fff)
}

[dir=ltr] .timeline-item[data-v-4d50203e]:last-of-type:after {
  left: 0
}

[dir=rtl] .timeline-item[data-v-4d50203e]:last-of-type:after {
  right: 0
}

.timeline-item .timeline-item-point[data-v-4d50203e] {
  position: absolute;
  width: 12px;
  height: 12px;
  top: 0;
  z-index: 1
}

[dir] .timeline-item .timeline-item-point[data-v-4d50203e] {
  border-radius: 50%
}

[dir=ltr] .timeline-item .timeline-item-point[data-v-4d50203e] {
  left: -6px
}

[dir=rtl] .timeline-item .timeline-item-point[data-v-4d50203e] {
  right: -6px
}

.timeline-item .timeline-item-point[data-v-4d50203e]:before {
  content: "";
  z-index: 1;
  width: 20px;
  height: 20px;
  position: absolute;
  top: -4px;
  bottom: 0
}

[dir] .timeline-item .timeline-item-point[data-v-4d50203e]:before {
  border-radius: 50%
}

[dir=ltr] .timeline-item .timeline-item-point[data-v-4d50203e]:before {
  left: -4px;
  right: 0
}

[dir=rtl] .timeline-item .timeline-item-point[data-v-4d50203e]:before {
  right: -4px;
  left: 0
}

.timeline-item .timeline-item-icon[data-v-4d50203e] {
  position: absolute;
  top: 0;
  width: 24px;
  height: 24px;
  z-index: 1
}

[dir] .timeline-item .timeline-item-icon[data-v-4d50203e] {
  background-color: #fff
}

[dir=ltr] .timeline-item .timeline-item-icon[data-v-4d50203e] {
  left: -12px
}

[dir=rtl] .timeline-item .timeline-item-icon[data-v-4d50203e] {
  right: -12px
}

[dir] .dark-layout .timeline-item[data-v-4d50203e]:last-of-type:after {
  background: -webkit-gradient(linear, left top, left bottom, from(#3b4253), to(#283046));
  background: linear-gradient(#3b4253, #283046)
}

[dir=ltr] .dark-layout .timeline-item[data-v-4d50203e]:not(:last-of-type) {
  border-left-color: #3b4253
}

[dir=rtl] .dark-layout .timeline-item[data-v-4d50203e]:not(:last-of-type) {
  border-right-color: #3b4253
}

[dir] .dark-layout .timeline-item .timeline-item-icon[data-v-4d50203e] {
  background-color: #283046
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
</style>
